import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import 'rc-slider/assets/index.css';
import MapChart from './world-map';
import Loading from './loading';

function MapDocente(props) {
  const { id, getMap, dep } = props;
  const [map, setMap] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getMap({ id }).then((res) => {
      setMap(res);
      setIsLoading(false);
    });
  }, []);

  return (
    <div>
      {
        isLoading
          ? <Loading />
          : <MapChart countries={map} dep={dep} />
      }
    </div>
  );
}

MapDocente.propTypes = {
  dep: PropTypes.string.isRequired,
  getMap: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};

export default MapDocente;
